import React from "react";
import { Provider } from "react-redux";
import store from "../stores/reduxStore";
import { Router, Route } from "react-router-dom";
import browserHistory from "../helpers/history";
import { ThemeProvider } from "styled-components";

import NounProjectHeader from "../components/nounproject-header";

import { LegacyUserContextProvider } from "contexts/CurrentUserContext";

import theme from "../themes/theme";

import { BannersProvider } from "frontend/context/BannersContext";
import { CookieConsentProvider } from "frontend/context/CookieConsentContext";

class NounProjectHeaderParent extends React.Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <BannersProvider>
                        <CookieConsentProvider>
                            <LegacyUserContextProvider>
                                <Router history={browserHistory}>
                                    <Route
                                        component={routerProps => (
                                            <NounProjectHeader
                                                {...this.props}
                                                {...routerProps}
                                            />
                                        )}
                                    />
                                </Router>
                            </LegacyUserContextProvider>
                        </CookieConsentProvider>
                    </BannersProvider>
                </Provider>
            </ThemeProvider>
        );
    }
}

export default NounProjectHeaderParent;
